import { SparkLineWithIllustration as HygraphSparkLineWithIllustration } from '@/lib/types';

import SparkLineWithIllustration from '@/components/spark-line-with-illustration';

import hygraphImageTransformer from '@/hygraph/transformers/hygraph-image.transformer';

export default function SparkLineWithIllustrationRenderer(
  props: HygraphSparkLineWithIllustration
) {
  return (
    <SparkLineWithIllustration
      caption={props.caption || undefined}
      heading={props.heading || ''}
      content={props.content || ''}
      image={hygraphImageTransformer(props.illustration)}
    />
  );
}
